import { gql, useFragment, useReactiveVar } from '@apollo/client';
import { allDishesListVar } from 'app/apollo/reaction';
import { useMemo } from 'react';
import { isDesktop } from 'app/utils/resolution';
import { useParticipantIdABTest } from '../Menu/Menu/hooks/useParticipantIdABTest';

// eslint-disable-next-line no-underscore-dangle
const __getIngredientsList = (parentId: number, allDishesList: any[]) => {
    const dishesWithSameParentId = allDishesList.filter(
        (item) => (item.parentId === parentId || item.secondDishPartID === parentId)
            && (item.secondDishPart || item.secondDishPartNM),
    );
    // console.log(dishesWithSameParentId, 'dishesWithSameParentId');
    const clearDishesList = dishesWithSameParentId.map(
        (item) => ({
            id: item.id,
            replaceableIngredient: item.replaceableIngredient,
            secondDishPart: item.secondDishPart,
            secondDishPartNM: item.secondDishPartNM,
            secondDishPartID: item.secondDishPartID,
        }),
    );
    return clearDishesList;
};

/**
 * @description хук опеределяет есть ли у dish'a кастомы по secondDishPart,
 * parentId, replaceableIngredient,
 * @return ingredientsList, isDishCardWithCustomSelect
 */
export function useDishCustoms(dishId: string = '') {
    const allDishesList = useReactiveVar(allDishesListVar);
    const isDesktopResolution = isDesktop();

    const { data } = useFragment({
        fragment: gql`
            fragment DISH_CUSTOMS_PART_FRAGMENT on menuDish {
                parentId
                secondDishPart
                secondDishPartNM
                secondDishPartID
                upsell_dishes {
                    id
                    title
                    name_upsell
                    price
                    portions
                }
            }
        `,
        from: {
            __ref: `menuDish:${dishId}`,
        },
    }) || { data: {} };

    const {
        parentId,
        secondDishPart,
        secondDishPartNM,
        secondDishPartID,
        upsell_dishes: upsellDishesList = [],
    } = data || {};

    const ingredientsList = useMemo(
        // @ts-ignore
        () => __getIngredientsList(!isDesktopResolution ? secondDishPartID || parentId : parentId, allDishesList),
        [parentId, secondDishPartID, allDishesList, isDesktopResolution],
    );

    const isDishCardWithCustomSelect = useMemo(
        () => {
            if (!isDesktopResolution) {
                return Boolean(secondDishPart) && secondDishPart !== 5 && secondDishPartNM !== 5 && ingredientsList.length > 1;
            }
            return Boolean(secondDishPart) && ingredientsList.length > 1;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [secondDishPart, ingredientsList, isDesktopResolution],
    );

    const isDishCardWithCustomTabBar = useMemo(
        () => ingredientsList.length > 1 && ingredientsList.some((item) => item.secondDishPartNM === 5 || item.secondDishPart === 5),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [secondDishPart, ingredientsList],
    );

    const isDishWithAdditionalDishesSelect = useMemo(
        () => upsellDishesList.length > 0,
        [upsellDishesList],
    );

    const isDishCustomized = isDishCardWithCustomSelect || isDishCardWithCustomTabBar;

    return {
        ingredientsList,
        upsellDishesList: [
            {
                id: null,
                name_upsell: 'Дополнить блюдо? Нет',
                portions: [0],
            },
            ...upsellDishesList,
        ],
        isDishCardWithCustomSelect,
        isDishCardWithCustomTabBar,
        isDishCustomized,
        isDishWithAdditionalDishesSelect,
    };
}
